import { render, staticRenderFns } from "./shikkadood.vue?vue&type=template&id=921b02b8&scoped=true"
import script from "./shikkadood.vue?vue&type=script&lang=js"
export * from "./shikkadood.vue?vue&type=script&lang=js"
import style0 from "./shikkadood.vue?vue&type=style&index=0&id=921b02b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921b02b8",
  null
  
)

export default component.exports